import type { ReactNode } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { MHMDialog } from '../MHM/MHMDialog';
import { MHMTypography } from '../MHM/MHMTypography';
import { MHMButton } from '../MHM/MHMButton';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  message?: ReactNode;
  children?: ReactNode;
};

export function ConfirmSaveModal({
  open,
  onCancel,
  onConfirm,
  message,
  children,
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle textAlign="center">{t('Confirm Settings')}</DialogTitle>
      <MHMDialog.Content>
        <MHMTypography textAlign="center">{message}</MHMTypography>
        {children}
      </MHMDialog.Content>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <MHMButton color="inherit" onClick={onCancel} sx={{ flex: 1 }}>
          {t('Cancel')}
        </MHMButton>
        <MHMButton
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{ flex: 1 }}
        >
          {t('Save')}
        </MHMButton>
      </DialogActions>
    </Dialog>
  );
}
